export const googleTicketKey = 'mc_google_handoff';
export const googleStateKey = 'mc_google_oauth_state';
export const googleResultKey = 'mc_google_oauth_result';
type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
const opaque = (value: string | null): value is string => Boolean(value && /^[A-Za-z0-9_-]{43}$/.test(value));

// Run before the SSO startup inspects code/state. Google callback values must
// never be interpreted as the OIDC login callback or retained in navigation.
export function captureGoogleNavigation(path: string, search: string, storage: StorageLike): string | null {
  if (path !== '/connections/google' && path !== '/connections/google/callback') return null;
  const params = new URLSearchParams(search);
  if (path.endsWith('/callback')) {
    const state = params.get('state');
    const code = params.get('code');
    const expected = storage.getItem(googleStateKey);
    storage.removeItem(googleStateKey);
    if (opaque(state) && state === expected && code && code.length <= 4096 && !params.has('error')) {
      storage.setItem(googleResultKey, JSON.stringify({ state, code }));
    } else {
      storage.setItem(googleResultKey, JSON.stringify({ error: 'Google connection did not complete. Please connect again.' }));
    }
  } else if (params.has('ticket')) {
    const ticket = params.get('ticket');
    storage.removeItem(googleTicketKey);
    if (opaque(ticket)) storage.setItem(googleTicketKey, ticket);
  }
  return '/connections/google';
}
